import React from 'react'
import '../../styles/components/footer.scss'

const Footer = () => {
    const date = new Date().getFullYear()

    return (
        <div className='footer'>Copyright © 2017-{date} iProforma.com. All rights reserved. V.W1.17.8, V.S1.17.8</div>
    )
}

export default Footer